import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-16 md:py-28 px-5 md:px-8 bg-carbon relative overflow-hidden" data-id="element-115">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-116" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-118">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-gold mb-8 md:mb-10 leading-tight" data-id="element-119">
            Cada hora con la silla vacía es dinero que no vuelve.
          </h2>

          <CTAButton scrollToId="contacto" className="w-full sm:w-auto text-lg md:text-xl py-5 px-10 mb-5" data-id="element-120">
            LLENA MI AGENDA AHORA
          </CTAButton>

          <p className="text-gray-500 text-xs md:text-sm mb-2" data-id="element-121">
            Cupos limitados por zona geográfica. Solo trabajamos con un salón
            por ciudad para evitar conflictos.
          </p>
          <p className="text-gray-500 text-xs md:text-sm" data-id="element-122">
            ¿Prefieres agendar directamente?{' '}
            <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold underline underline-offset-2 hover:text-gold/80 transition-colors" data-id="element-123">
              Reserva en nuestro calendario →
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}